import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IPatientRes, IPatient } from "./index.type";

const useAllPatient = ({
  pageNumber,
  searchKey,
  associatedClinic,
  status,
  transmission,
  billingCycleLeftDays,
  sort,
  order,
  accountowner,
  prequalified,
  billingCycleNumber,
  alerts,
  phoneCallReminderDate,
}: {
  pageNumber: number;
  searchKey: string;
  associatedClinic: string;
  status: string;
  transmission: string;
  billingCycleLeftDays?: string;
  sort?: string;
  order?: "asc" | "desc";
  accountowner?: string;
  prequalified?: string;
  billingCycleNumber?: string;
  alerts?: string;
  phoneCallReminderDate?: string;
}) => {
  const [patientData, setPatientData] = React.useState<IPatientRes>();

  const buildQueryString = () => {
    const params = new URLSearchParams();

    const trimmedSearch =
      typeof searchKey === "string"
        ? searchKey.trim().replace(/\s+/g, " ")
        : "";
    const trimmedBillingCycle =
      typeof billingCycleNumber === "string" ? billingCycleNumber.trim() : "";

    if (trimmedSearch) params.append("search", trimmedSearch);
    if (associatedClinic) params.append("associatedClinic", associatedClinic);
    if (status) params.append("status", status);
    if (transmission) params.append("transmission", transmission);
    if (sort) params.append("sort", sort);
    if (order) params.append("order", order);
    params.append("page", pageNumber.toString());
    if (billingCycleLeftDays !== undefined)
      params.append("timeSpent", billingCycleLeftDays);
    if (accountowner) params.append("accountowner", accountowner);
    if (prequalified) params.append("preQualified", prequalified);
    if (trimmedBillingCycle)
      params.append("billingCycleNumber", trimmedBillingCycle);
    if (alerts) params.append("alertMessage", alerts);
    if (phoneCallReminderDate)
      params.append("phoneCallReminderDate", phoneCallReminderDate);

    return params.toString();
  };


  const { loading: patientDataLoading, makeApiCall } = useApi({
    url: `/rtm/patient-enrollment?${buildQueryString()}`,
    method: "GET",
  });

  const getpatientData = async () => {
    const { response, error } = await makeApiCall<undefined, IPatientRes>();
    if (response?.status) {
      setPatientData(response);
      return;
    }

    if (!response?.status) {
      setPatientData(undefined);
    }

    if (error)
      toast.error(
        "Something went wrong while fetching providers data. Please try again later"
      );
  };

  return {
    patientData,
    getpatientData,
    patientDataLoading,
    setPatientData,
  };
};

export default useAllPatient;
